// 专业培训
<template>
  <div>
    <div class="main">
      <div class="banana">
        <img src="../assets/img/banner/专项.png" alt />
      </div>
      <div class="center">
        <div class="nav">
          <p>
            当前位置：
            <span @click="shouye" class="navvv">首页</span> > 专项培训
          </p>
        </div>
        <h1 class="title">专项培训</h1>
        <div class="one">
          <div class="biaotiOne">
            <span class="blue"></span>
            <h2>工程项目培训</h2>
          </div>
          <p class="xiangqing">针对性的开展提升工程质量、安全、新技术应用、绿色施工等方面的系统培训。</p>
          <div class="left">
            <div class="oneImg">
              <img src="../assets/img/专项培训/技术@2x.png" />
            </div>
            <h4>单项技术提升方面</h4>
            <p>根据企业需求为企业定制全年培训计划，对项目进行宣贯培训，指导项目部及时对BIM、新技术应用、绿色施工、工法、QC、质量标准化工地等形成成套成果，提升项目总结能力，促进企业成果转换和积累。</p>
          </div>
          <div class="right">
            <div class="twoImg">
              <img src="../assets/img/专项培训/资料.png" />
            </div>
            <h4>技术资料方面</h4>
            <p>从工程准备阶段、工程实施阶段到工程资料移交，通过现场培训 、规范讲解，全方位梳理施工全过程资料整理要点。保证资料真实有效、编目清晰、具有可追溯性。</p>
          </div>
        </div>
        <div class="two"></div>
        <div class="three">
          <div class="biaotiTwo">
            <span class="blue"></span>
            <h2>行业前沿技术培训</h2>
          </div>
        </div>
        <div class="four">
          <div class="fourLeft">
            <p>针对当前信息技术发展的新方向、新动向，如何将信息技术有机融入建筑企业管理、工程项目管理、建造过程管理、风险管控等方面，提升企业的管理能力、决策效率和建造水平，进而提高企业经济效益和竞争力。</p>
            <p>针对建筑企业在推动装配式建筑方面的困惑，通过系统培训、专家现场指导，提供相应解决方案。</p>
          </div>
          <div class="fourRight"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  methods: {
    shouye() {
      this.$router.replace("/");
    },
  },
  components: {},
};
</script>

<style scoped lang="less">
.main {
  width: 100%;
  font-size: 16px;
  .banana {
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
    // background: url("../assets/img/banner/专项.png") center no-repeat;
    // background-size: cover;
  }
  .center {
    width: 1160px;
    margin: 0 auto;
    // padding: 0px 360px;
    box-sizing: border-box;
    overflow: hidden;
    .nav {
      width: 100%;
      border-bottom: 1px solid #a0a0a0;
      opacity: 1;
      font-size: 12px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #666666;
      line-height: 36px;
      margin-bottom: 50px;
    }
    .title {
      opacity: 1;
      font-size: 35px;
      font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
      font-weight: 700;
      text-align: center;
      color: #4279db;
    }
    .one {
      margin-left: 36px;
      margin-bottom: 166px;
      .biaotiOne {
        width: 100%;
        height: 66px;
        position: relative;
      }
      .xiangqing {
        opacity: 1;
        font-size: 16px;
        font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
        font-weight: 400;
        text-align: left;
        color: #231815;
      }
      .left {
        margin-top: 82px;
        width: 376px;
        height: 314px;
        padding: 50px 18px;
        background: #ffffff;
        border: 2px solid #b5b5b5;
        border-radius: 12px;
        box-sizing: border-box;
        float: left;
        position: relative;
        left: 130px;
        .oneImg {
          width: 72px;
          height: 72px;
          line-height: 90px;
          text-align: center;
          position: absolute;
          top: -40px;
          left: 140px;
          border: 2px solid #b5b5b5;
          border-radius: 50%;
          background: #fff;
          img {
            width: 36px;
            height: 36px;
          }
        }
        h4 {
          opacity: 1;
          font-size: 21px;
          font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
          font-weight: 400;
          text-align: center;
          color: #4279db;
          margin-bottom: 27px;
        }
        p {
          opacity: 1;
          font-size: 14px;
          font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
          font-weight: 400;
          text-align: justifyLeft;
          color: #333333;
          line-height: 30px;
          text-indent: 2em;
        }
      }
      .right {
        width: 376px;
        height: 314px;
        padding: 20px 18px;
        background: #ffffff;
        border: 2px solid #b5b5b5;
        border-radius: 12px;
        box-sizing: border-box;
        position: relative;
        left: 590px;
        top: 82px;
        .twoImg {
          width: 72px;
          height: 72px;
          position: absolute;
          line-height: 90px;
          text-align: center;
          top: -40px;
          left: 140px;
          border: 2px solid #b5b5b5;
          border-radius: 50%;
          background: #fff;
          img {
            width: 36px;
            height: 36px;
          }
        }
        h4 {
          opacity: 1;
          font-size: 21px;
          font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
          font-weight: 400;
          text-align: center;
          color: #4279db;
          margin-bottom: 27px;
          position: absolute;
          top: 50px;
          left: 126px;
        }
        p {
          opacity: 1;
          font-size: 14px;
          width: 333px;
          font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
          font-weight: 400;
          text-align: justifyLeft;
          color: #333333;
          line-height: 30px;
          text-indent: 2em;
          position: absolute;
          top: 105px;
        }
      }
    }
    .three {
      margin-left: 36px;
      margin-bottom: 3px;
      .biaotiTwo {
        width: 100%;
        height: 66px;
        position: relative;
      }
    }
    .four {
      width: 100%;
      height: 370px;
      margin-bottom: 107px;
      .fourLeft {
        width: 572px;
        height: 196px;
        opacity: 1;
        font-size: 16px;
        font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
        font-weight: 400;
        text-align: justifyLeft;
        color: #231815;
        text-indent: 2em;
        line-height: 45px;
        float: left;
      }
      .fourRight {
        width: 511px;
        height: 370px;
        opacity: 1;
        float: right;
        background: url("../assets/img/专项培训/f23e1d3ef7e54005ac01a02784ec74f4@3x.png")
          center no-repeat;
        background-size: cover;
      }
    }
  }
}
.blue {
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #3781e1;
  position: absolute;
  left: -30px;
  top: 10px;
}
h2 {
  opacity: 1;
  font-size: 25px;
  font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
  font-weight: 700;
  text-align: justifyLeft;
  color: #231815;
}
</style>
